<template>
  <img :src="imgSRC" class="mr-3" width="200px" @click="emitClick()" :class="clicable ? 'arp-cursor-pointer' : ''" />
</template>

<script>
export default {
  name: 'Logo',
  props: {
    clicable: {
      type: Boolean,
      default: () => false,
    },
    imgSRC: {
      type: String,
      default: () => '/img/logo-color.png',
    },
  },
  methods: {
    emitClick() {
      this.$emit('click')
    },
  },
}
</script>

<style lang="scss" scoped>
h1 {
  font-size: 26.5px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.21;
  letter-spacing: normal;
  text-align: left;
  color: #22252b;
  span {
    font-weight: 300;
  }
}

.arp-cursor-pointer {
  cursor: pointer;
}
</style>
